import engine from 'store/src/store-engine';
import localStorage from 'store/storages/localStorage';
import cookieStorage from 'store/storages/cookieStorage';
import defaultsPlugin from 'store/plugins/defaults';
import expirePlugin from 'store/plugins/expire';
import observePlugin from 'store/plugins/observe';

const storages = [localStorage, cookieStorage];
const plugins = [defaultsPlugin, expirePlugin, observePlugin];

export default engine.createStore(storages, plugins, process.env.REACT_APP_NAME);
